import { useInputCompositionContext } from "../../../../../hooks/useInputCompositionContext/useInputCompositionContext";

import React, { useState, useEffect, useRef } from "react";

const ICTimePickerSelect = ({
                                field,
                                placeholder = "Выберите время",
                                timeIntervals = 15,
                                minTime,
                                maxTime,
                                filterTime,
                                disabled = false,
                                // Новые пропсы для определения, какое поле содержит дату
                                dateField = "startsAtDate", // поле с датой по умолчанию
                                // Проп для доступа к полной модели состояния (если нужно)
                                getCurrentTimeForToday = null, // функция для получения текущего времени
                            }) => {
    const [stateModel, setStateModel, isError, setIsError] = useInputCompositionContext();

    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [displayValue, setDisplayValue] = useState(stateModel?.[field] || "");
    const dropdownRef = useRef(null);
    const searchInputRef = useRef(null);

    // Синхронизация с контекстом
    useEffect(() => {
        const currentValue = stateModel?.[field] || "";
        setDisplayValue(currentValue);
    }, [stateModel, field]);

    // Функция для получения текущего времени с округлением вверх до ближайшего интервала
    const getCurrentRoundedTime = () => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();

        // Округляем минуты вверх до ближайшего интервала
        const roundedMinute = Math.ceil(currentMinute / timeIntervals) * timeIntervals;

        let hour = currentHour;
        let minute = roundedMinute;

        // Если минуты перевалили за 60, увеличиваем час
        if (minute >= 60) {
            hour += 1;
            minute = 0;

            // Если час перевалил за 24, сбрасываем
            if (hour >= 24) {
                hour = 0;
            }
        }

        return {
            hour,
            minute,
            toString: () => `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`,
        };
    };

    // Функция для проверки, является ли выбранная дата сегодняшней
    const isToday = (dateString) => {
        if (!dateString) return false;

        try {
            const selectedDate = new Date(dateString);
            const today = new Date();

            return selectedDate.getDate() === today.getDate() &&
                selectedDate.getMonth() === today.getMonth() &&
                selectedDate.getFullYear() === today.getFullYear();
        } catch (error) {
            console.error("Error checking if date is today:", error);
            return false;
        }
    };

    // Функция для получения актуального minTime с учетом текущего времени
    const getActualMinTime = () => {
        // Если передан явный minTime, используем его
        if (minTime) return minTime;

        // // Проверяем, если у нас есть поле с датой
        // const selectedDate = stateModel?.[dateField];
        //
        // // Если дата выбрана и это сегодня
        // if (selectedDate && isToday(selectedDate)) {
        //     // Если это время начала, используем текущее время
        //     if (field === "startsAtTime" || field === "endsAtTime") {
        //         const currentTime = getCurrentRoundedTime();
        //         console.log(`[${field}] Today selected, using current time:`, currentTime.toString());
        //         return currentTime.toString();
        //     }
        // }

        return null;
    };

    // Генерация опций времени с поиском
    const generateTimeOptions = () => {
        const options = [];
        const actualMinTime = getActualMinTime();

        console.log(`[${field}] Generating time options with minTime:`, actualMinTime, "maxTime:", maxTime);

        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += timeIntervals) {
                const timeString = `${hour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")}`;

                let isValid = true;

                // Фильтр по actualMinTime (с учетом текущего времени для сегодня)
                if (actualMinTime) {
                    const [minHour, minMinute] = actualMinTime.split(":").map(Number);
                    const totalMinutes = hour * 60 + minute;
                    const minTotalMinutes = minHour * 60 + minMinute;

                    if (totalMinutes < minTotalMinutes) {
                        isValid = false;
                    }
                }

                // Фильтр по maxTime
                if (maxTime && isValid) {
                    const [maxHour, maxMinute] = maxTime.split(":").map(Number);
                    const totalMinutes = hour * 60 + minute;
                    const maxTotalMinutes = maxHour * 60 + maxMinute;
                    isValid = isValid && (totalMinutes <= maxTotalMinutes);
                }

                // Пользовательский фильтр
                if (filterTime && isValid) {
                    const timeObj = new Date();
                    timeObj.setHours(hour, minute, 0, 0);
                    isValid = filterTime(timeObj);
                }

                // Поиск по вводу
                if (searchTerm && isValid) {
                    isValid = timeString.includes(searchTerm);
                }

                if (isValid) {
                    options.push(timeString);
                }
            }
        }

        console.log(`[${field}] Generated ${options.length} options`);
        return options;
    };

    const timeOptions = generateTimeOptions();

    const handleTimeSelect = (timeString) => {
        console.log(`[${field}] handleTimeSelect:`, timeString);

        setDisplayValue(timeString);

        // Обновляем контекст
        setStateModel(prev => {
            const newState = {
                ...prev,
                [field]: timeString,
            };
            console.log(`[${field}] Updated stateModel:`, newState);
            return newState;
        });

        // Очищаем ошибку
        if (isError?.[field]) {
            setIsError(prev => {
                const temp = { ...prev };
                delete temp[field];
                return temp;
            });
        }

        setIsOpen(false);
        setSearchTerm("");
    };

    const handleInputClick = () => {
        if (!disabled) {
            setIsOpen(!isOpen);
            if (!isOpen) {
                // Фокус на поле поиска при открытии
                setTimeout(() => {
                    if (searchInputRef.current) {
                        searchInputRef.current.focus();
                    }
                }, 0);
            }
        }
    };

    // Закрытие при клике вне
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
                setSearchTerm("");
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && isOpen && timeOptions.length > 0) {
            handleTimeSelect(timeOptions[0]);
        } else if (e.key === "Escape") {
            setIsOpen(false);
            setSearchTerm("");
        }
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
        if (!isOpen) setIsOpen(true);
    };

    // Логируем информацию о дате
    useEffect(() => {
        const selectedDate = stateModel?.[dateField];
        console.log(`[${field}] Selected date:`, selectedDate, "Is today?", isToday(selectedDate));
    }, [stateModel?.[dateField], field, dateField]);

    return (
        <div
            ref={dropdownRef}
            style={{
                "position": "relative",
                "width": "290px",
                "fontFamily": "Arial, sans-serif",
            }}
        >
            {/* Поле ввода */}
            <div
                onClick={handleInputClick}
                style={{
                    "padding": "12px 0",
                    "cursor": disabled ? "not-allowed" : "pointer",
                    "minHeight": "40px",
                    "display": "flex",
                    "alignItems": "center",
                    "justifyContent": "space-between",
                    "borderBottom": isError?.[field]
                        ? "1px solid red"
                        : "1px solid #EEEEEE",
                    "userSelect": "none",
                }}
            >
                <div style={{
                    "fontSize": "14px",
                    "color": displayValue ? "#000" : "#999",
                }}>
                    {displayValue || placeholder}
                </div>
                {!disabled && (
                    <span style={{
                        "width": "0",
                        "height": "0",
                        "borderLeft": "5px solid transparent",
                        "borderRight": "5px solid transparent",
                        "borderTop": isOpen ? "none" : "5px solid #999",
                        "borderBottom": isOpen ? "5px solid #999" : "none",
                    }}></span>
                )}
            </div>

            {/* Выпадающий список с поиском */}
            {isOpen && !disabled && (
                <div style={{
                    "position": "absolute",
                    "top": "100%",
                    "left": "0",
                    "right": "0",
                    "background": "#fff",
                    "border": "1px solid #ddd",
                    "borderRadius": "4px",
                    "boxShadow": "0 4px 12px rgba(0, 0, 0, 0.1)",
                    "zIndex": "1000",
                    "maxHeight": "300px",
                    "overflowY": "auto",
                }}>
                    {/* Поле поиска */}
                    <div style={{
                        "padding": "10px",
                        "borderBottom": "1px solid #eee",
                        "position": "sticky",
                        "top": "0",
                        "background": "#fff",
                        "zIndex": "1",
                    }}>
                        <input
                            ref={searchInputRef}
                            type="text"
                            style={{
                                "width": "100%",
                                "padding": "8px",
                                "border": "1px solid #ddd",
                                "borderRadius": "4px",
                                "fontSize": "14px",
                                "outline": "none",
                            }}
                            placeholder="Поиск времени..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                            onKeyDown={handleKeyDown}
                            onClick={(e) => e.stopPropagation()}
                        />
                    </div>

                    {/* Список времени */}
                    <div style={{
                        "maxHeight": "250px",
                        "overflowY": "auto",
                    }}>
                        {timeOptions.length > 0 ? (
                            timeOptions.map((time, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleTimeSelect(time)}
                                    style={{
                                        "padding": "10px 15px",
                                        "cursor": "pointer",
                                        "fontSize": "14px",
                                        "backgroundColor": displayValue === time ? "#e6f7ff" : "transparent",
                                        "color": displayValue === time ? "#1890ff" : "#333",
                                        "borderBottom": index < timeOptions.length - 1 ? "1px solid #f0f0f0" : "none",
                                        "transition": "background-color 0.2s",
                                    }}
                                    onMouseEnter={(e) => {
                                        if (displayValue !== time) {
                                            e.target.style.backgroundColor = "#f5f5f5";
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (displayValue !== time) {
                                            e.target.style.backgroundColor = "transparent";
                                        }
                                    }}
                                >
                                    {time}
                                </div>
                            ))
                        ) : (
                            <div style={{
                                "padding": "20px 15px",
                                "textAlign": "center",
                                "color": "#999",
                                "fontStyle": "italic",
                                "fontSize": "14px",
                            }}>
                                Время не найдено
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ICTimePickerSelect;
